"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.contentLoopConfig = void 0;
var react_1 = __importDefault(require("react"));
var Types_1 = require("@CommonFrontend/ContentTokens/Models/inputs/Types");
var slate_1 = require("slate");
var MakeConfig_1 = require("../Utils/MakeConfig");
var GetCommonConfigByType_1 = require("@CommonFrontend/WidgetRegistry/Utils/GetCommonConfigByType");
var ContentLoopRegistryWidget_1 = require("Project/QwilrEditor/Widgets/ContentLoopWidget/ContentLoopRegistryWidget");
var Utils_1 = require("Project/QwilrEditor/Utils");
var Serialise_1 = require("Project/QwilrEditor/Tokenization/Serialise");
var CommonUtils_1 = require("@CommonFrontendBackend/Utils/CommonUtils");
var Deserialise_1 = require("Project/QwilrEditor/Tokenization/Deserialise");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var ContentLoopToolbarButtons_1 = require("Project/QwilrEditor/Widgets/ContentLoopWidget/ContentLoopToolbarButtons");
var ContentLoopWidgetContext_1 = require("Project/QwilrEditor/Widgets/ContentLoopWidget/ContentLoopWidgetContext");
var EditorWidgetRegistry_1 = require("../EditorWidgetRegistry");
var TokenizationErrorRecorder_1 = require("Project/QwilrEditor/Tokenization/TokenizationErrorRecorder");
var createContentLoopNode = function () { return ({
    type: "contentLoop",
    children: [(0, EditorWidgetRegistry_1.createContentLoopBodyNode)()],
    data: {},
    isVoid: false,
}); };
exports.contentLoopConfig = (0, MakeConfig_1.makeConfig)(__assign(__assign({}, (0, GetCommonConfigByType_1.getCommonConfigByType)("contentLoop")), { node: {}, nodeType: "layoutElement", editorRender: ContentLoopRegistryWidget_1.ContentLoopRegistryWidget, onAddWidget: function (_a) {
        var editor = _a.editor;
        if (!editor.selection) {
            return;
        }
        var nodeEntry = (0, Utils_1.getClosestBlock)(editor, editor.selection.anchor.path);
        if (!nodeEntry) {
            return;
        }
        var _b = __read(nodeEntry, 2), path = _b[1];
        var contentLoopNode = createContentLoopNode();
        (0, Utils_1.replaceNodes)(editor, contentLoopNode, { at: path });
    }, normalizeWidget: function (node, path, editor, schema) {
        if (!node.children.length || node.children[0].type !== "contentLoopBody") {
            slate_1.Transforms.insertNodes(editor, (0, EditorWidgetRegistry_1.createContentLoopBodyNode)(), { at: __spreadArray(__spreadArray([], __read(path), false), [0], false) });
            return true;
        }
        if (node.children.length > 1) {
            slate_1.Transforms.removeNodes(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [1], false) });
            return true;
        }
        return false;
    }, serialise: function (node, editor, commentTracker, selection) {
        var body = (0, Serialise_1.serialiseElements)(node.children[0].children, editor, commentTracker, selection);
        if (body.length === 0) {
            (0, TokenizationErrorRecorder_1.sendEmptyLayoutToSentry)("contentLoop", "contentLoopBody", "serialisation");
        }
        var token = __assign({ type: "block", subType: "contentLoop", content: body }, (0, CommonUtils_1.includeIf)(!!node.data.variable, { variable: node.data.variable }));
        return [token];
    }, deserialise: function (token, content, commentTracker) {
        var deserialisedContentLoopBodyChildren = (0, Deserialise_1.deserialiseNode)(token.content, commentTracker).children;
        if (deserialisedContentLoopBodyChildren.length === 0) {
            (0, TokenizationErrorRecorder_1.sendEmptyLayoutToSentry)("contentLoop", "contentLoopBody", "deserialisation");
        }
        return {
            type: "contentLoop",
            isVoid: false,
            data: __assign({}, (0, CommonUtils_1.includeIf)(!!token.variable, { variable: __assign(__assign({}, token.variable), { dataSource: Types_1.DataSource.Token }) })),
            children: [{ children: deserialisedContentLoopBodyChildren, isVoid: false, type: "contentLoopBody" }],
        };
    }, firstLastConfiguration: {
        isValidFirstChild: true,
    }, validContainers: [], validEditors: ["standard"], width: "full-width", containerNodeConfiguration: {
        showWidgetAdder: false,
        validChildren: [],
        hasContainerManagedChildren: true,
    }, widgetAdderConfig: {
        icon: react_1.default.createElement(icons_1.Loop, null),
        requiresFeatures: [FeatureFlag_1.default.PublicApi],
        displayName: "Repeating content",
        tags: ["content loop", "loop", "looping", "for", "foreach", "variable", "repeat", "repeating"],
    }, requiresTokenAvailability: true, toolbarButtons: ContentLoopToolbarButtons_1.ContentLoopToolbarButtons, widgetContextProvider: ContentLoopWidgetContext_1.ContentLoopWidgetContextProvider }));
